module.exports = __webpack_public_path__ + "media/images/common/logo_white-1c1bbedacbf365595867add4950bb545.png";